import { TGetMeDto } from "@/api/services/main/auth/dtos/get-me.dto";
import { Button } from "@/components/elements/Button";
import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { background, divider, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Control } from "react-hook-form";

import { TUserSettingEditForm } from "@/features/user-setting/types/userSettingEditForm";

type TAccountBasicInfoFieldsProps = {
  control: Control<TUserSettingEditForm>;
  me: TGetMeDto;
};

export const AccountBasicInfoFields: FC<TAccountBasicInfoFieldsProps> = ({ control, me }) => {
  const pendingEmail = me.newEmail;

  return (
    <InnerBox title="アカウント基本情報" padding="24px">
      <Stack direction="row" gap="24px" alignItems="flex-start" flexWrap="wrap">
        <Stack direction="row" gap="48px" flex={1} minWidth={0} flexWrap="wrap">
          <Stack flex={1} minWidth="240px">
            <FormField control={control} name="fullName">
              <Input placeholder="入力してください" />
            </FormField>
          </Stack>

          <Stack flex={1} minWidth="240px" gap="4px">
            <Typography variant="cap12" color={text.primary}>
              メールアドレス
            </Typography>
            {/* Read-only on the edit screen: change email from the Detail screen. */}
            <Box
              sx={{
                minHeight: "33px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                px: "8px",
                py: "6px",
                borderRadius: rounded.xs,
                border: `1px solid ${divider.middle}`,
                background: background.disable,
              }}
            >
              <Typography variant="body14" color={text.tertiary}>
                {me.email}
              </Typography>
              {pendingEmail && (
                <Typography variant="body14" color={text.tertiary}>
                  {pendingEmail} (確認中)
                </Typography>
              )}
            </Box>
          </Stack>
        </Stack>

        {/* Email changes go through the Detail screen; disabled while editing. */}
        <Stack minWidth="160px">
          <Button size="sm" variant="secondary" disabled>
            メールアドレス変更
          </Button>
        </Stack>
      </Stack>
    </InnerBox>
  );
};
